<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Space Exploration & Research </template>
    <template #description>
      Quantum technologies could advance space exploration and research by optimizing spacecraft trajectories, making missions more efficient and cost-effective. They will enable advanced navigation, mapping, and research, further refining our understanding of the universe. Quantum sensing could allow scientists to detect images beneath the Earth's surface, monitor gravity changes, track tectonic movements, and predict natural disasters. Additionally, quantum innovations will enhance time precision, improving synchronization for space missions and scientific experiments.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Space Exploration & Research" />
    </template>
  </LImpact>
</template>

<style scoped></style>
